// Here we will create svg as a react component 

//  export const PowerBtn = (props) => {
//     // copy svg code from website and refer to 29:35 for additional editing

//  }


export const PowerBtn = (props) => {
    return (
      <svg
        aria-hidden="true"
        data-prefix="fas"
        data-icon="power-off"
        className="prefix__svg-inline--fa prefix__fa-power-off prefix__fa-w-16"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 512 512"
        {...props}
      >
        <path
          fill={props.fill}
          d="M400 54.1c63 45 104 118.6 104 201.9 0 136.8-110.8 247.7-247.5 248C120 504.3 8.2 393 8 256.4 7.9 173.1 48.9 99.3 111.8 54.2c11.7-8.3 28-4.8 35 7.7L162.6 90c5.9 10.5 3.1 23.8-6.6 31-41.5 30.8-68 79.6-68 134.9-.1 92.3 74.5 168.1 168 168.1 91.6 0 168.6-74.2 168-169.1-.3-51.8-24.7-101.8-68.1-134-9.7-7.2-12.4-20.5-6.5-30.9l15.8-28.1c7-12.4 23.2-16.1 34.8-7.8zM296 264V24c0-13.3-10.7-24-24-24h-32c-13.3 0-24 10.7-24 24v240c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24z"
        />
      </svg>
    )
  }
  
  export const Github = (props) => {
      return (
          <svg
            aria-hidden="true"
            data-prefix="fab"
            data-icon="github"
            className="prefix__svg-inline--fa prefix__fa-github prefix__fa-w-16"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 496 512"
            {...props}
          >
            <path
              fill={props.fill}
              d="M165.9 397.4c0 2-2.3 3.6-5.2 3.6-3.3.3-5.6-1.3-5.6-3.6 0-2 2.3-3.6 5.2-3.6 3-.3 5.6 1.3 5.6 3.6zm-31.1-4.5c-.7 2 1.3 4.3 4.3 4.9 2.6 1 5.6 0 6.2-2s-1.3-4.3-4.3-5.2c-2.6-.7-5.5.3-6.2 2.3zm44.2-1.7c-2.9.7-4.9 2.6-4.6 4.9.3 2 2.9 3.3 5.9 2.6 2.9-.7 4.9-2.6 4.6-4.6-.3-1.9-3-3.2-5.9-2.9zM244.8 8C106.1 8 0 113.3 0 252c0 110.9 69.8 205.8 169.5 239.2 12.8 2.3 17.3-5.6 17.3-12.1 0-6.2-.3-40.4-.3-61.4 0 0-70 15-84.7-29.8 0 0-11.4-29.1-27.8-36.6 0 0-22.9-15.7 1.6-15.4 0 0 24.9 2 38.6 25.8 21.9 38.6 58.6 27.5 72.9 20.9 2.3-16 8.8-27.1 16-33.7-55.9-6.2-112.3-14.3-112.3-110.5 0-27.5 7.6-41.3 23.6-58.9-2.6-6.5-11.1-33.3 2.6-67.9 20.9-6.5 69 27 69 27 20-5.6 41.5-8.5 62.8-8.5s42.8 2.9 62.8 8.5c0 0 48.1-33.6 69-27 13.7 34.7 5.2 61.4 2.6 67.9 16 17.7 25.8 31.5 25.8 58.9 0 96.5-58.9 104.2-114.8 110.5 9.2 7.9 17 22.9 17 46.4 0 33.7-.3 75.4-.3 83.6 0 6.5 4.6 14.4 17.3 12.1C428.2 457.8 496 362.9 496 252 496 113.3 383.5 8 244.8 8zM97.2 352.9c-1.3 1-1 3.3.7 5.2 1.6 1.6 3.9 2.3 5.2 1 1.3-1 1-3.3-.7-5.2-1.6-1.6-3.9-2.3-5.2-1zm-10.8-8.1c-.7 1.3.3 2.9 2.3 3.9 1.6 1 3.6.7 4.3-.7.7-1.3-.3-2.9-2.3-3.9-2-.6-3.6-.3-4.3.7zm32.4 35.6c-1.6 1.3-1 4.3 1.3 6.2 2.3 2.3 5.2 2.6 6.5 1 1.3-1.3.7-4.3-1.3-6.2-2.2-2.3-5.2-2.6-6.5-1zm-11.4-14.7c-1.6 1-1.6 3.6 0 5.9 1.6 2.3 4.3 3.3 5.6 2.3 1.6-1.3 1.6-3.9 0-6.2-1.4-2.3-4-3.3-5.6-2z"
            />
          </svg>
        )
  }
  
  export const Twitter = (props) => {
      return (
          <svg
            aria-hidden="true"
            data-prefix="fab"
            data-icon="twitter"
            className="prefix__svg-inline--fa prefix__fa-twitter prefix__fa-w-16"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512 512"
            {...props}
          >
            <path
              fill={props.fill}
              d="M459.37 151.716c.325 4.548.325 9.097.325 13.645 0 138.72-105.583 298.558-298.558 298.558-59.452 0-114.68-17.219-161.137-47.106 8.447.974 16.568 1.299 25.34 1.299 49.055 0 94.213-16.568 130.274-44.832-46.132-.975-84.792-31.188-98.112-72.772 6.498.974 12.995 1.624 19.818 1.624 9.421 0 18.843-1.3 27.614-3.573-48.081-9.747-84.143-51.98-84.143-102.985v-1.299c13.969 7.797 30.214 12.67 47.431 13.319-28.264-18.843-46.781-51.005-46.781-87.391 0-19.492 5.197-37.36 14.294-52.954 51.655 63.675 129.3 105.258 216.365 109.807-1.624-7.797-2.599-15.918-2.599-24.04 0-57.828 46.782-104.934 104.934-104.934 30.213 0 57.502 12.67 76.67 33.137 23.715-4.548 46.456-13.32 66.599-25.34-7.798 24.366-24.366 44.833-46.132 57.827 21.117-2.273 41.584-8.122 60.426-16.243-14.292 20.791-32.161 39.308-52.628 54.253z"
            />
          </svg>
        )
  }
  
  export const Facebook = (props) => {
      return (
          <svg
            aria-hidden="true"
            data-prefix="fab"
            data-icon="facebook"
            className="prefix__svg-inline--fa prefix__fa-facebook prefix__fa-w-16"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512 512"
            {...props}
          >
            <path
              fill={props.fill}
              d="M504 256C504 119 393 8 256 8S8 119 8 256c0 123.78 90.69 226.38 209.25 245V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.28c-30.8 0-40.41 19.12-40.41 38.73V256h68.78l-11 71.69h-57.78V501C413.31 482.38 504 379.78 504 256z"
            />
          </svg>
        )
  }

  export const LinkedIn = (props) => {
    return (
      <svg
        aria-hidden="true"
        data-prefix="fab"
        data-icon="linkedin"
        className="prefix__svg-inline--fa prefix__fa-linkedin prefix__fa-w-16"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 448 512"
        {...props}
      >
        <path
          fill={props.fill}
          d="M100.28 448H7.4V148.9h92.88zm-46.44-340.5C24.16 107.5 0 83.13 0 53.74 0 24.36 24.16 0 53.84 0s53.84 24.36 53.84 53.74-24.16 53.74-53.84 53.74zM447.9 448H355V302.4c0-34.73-12.5-58.43-43.75-58.43-23.87 0-38.06 16.07-44.31 31.58-2.28 5.55-2.83 13.31-2.83 21.05V448H172.4s1.22-261.47 0-288.1h92.82v40.78c-.19.31-.43.62-.61.92h.61v-.92c12.34-19 34.36-46.08 83.58-46.08 61 0 106.69 39.85 106.69 125.49V448z"
        />
      </svg>
    );
  };
  
  
  export const YouTube = (props) => {
      return (
          <svg
            aria-hidden="true"
            data-prefix="fab"
            data-icon="youtube"
            className="prefix__svg-inline--fa prefix__fa-youtube prefix__fa-w-18"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 576 512"
            {...props}
          >
            <path
              fill={props.fill}
              d="M549.655 124.083c-6.281-23.65-24.787-42.276-48.284-48.597C458.781 64 288 64 288 64S117.22 64 74.629 75.486c-23.497 6.322-42.003 24.947-48.284 48.597-11.412 42.867-11.412 132.305-11.412 132.305s0 89.438 11.412 132.305c6.281 23.65 24.787 41.5 48.284 47.821C117.22 448 288 448 288 448s170.78 0 213.371-11.486c23.497-6.321 42.003-24.171 48.284-47.821 11.412-42.867 11.412-132.305 11.412-132.305s0-89.438-11.412-132.305zm-317.51 213.508V175.185l142.739 81.205-142.739 81.201z"
            />
          </svg>
        )
  }
  
  export const YinYang = (props) => {
      return (
          <svg
            aria-hidden="true"
            data-prefix="fas"
            data-icon="yin-yang"
            className="prefix__svg-inline--fa prefix__fa-yin-yang prefix__fa-w-16"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 496 512"
            {...props}
          >
            <path
              fill={props.fill}
              d="M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm0 376c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-128c-53.02 0-96 42.98-96 96s42.98 96 96 96c-106.04 0-192-85.96-192-192S141.96 64 248 64c53.02 0 96 42.98 96 96s-42.98 96-96 96zm0-128c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32z"
            />
          </svg>
        )
  }
  
  export const Anchor = (props) => {
    return (
      <svg
        aria-hidden="true"
        data-prefix="fas"
        data-icon="anchor"
        className="prefix__svg-inline--fa prefix__fa-anchor prefix__fa-w-18"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 576 512"
        {...props}
      >
        <path
          fill={props.fill}
          d="M12.971 352h32.394C67.172 454.735 181.944 512 288 512c106.229 0 220.853-57.38 242.635-160h32.394c10.691 0 16.045-12.926 8.485-20.485l-67.029-67.029c-4.686-4.686-12.284-4.686-16.971 0l-67.029 67.029c-7.56 7.56-2.206 20.485 8.485 20.485h35.146c-20.29 54.317-84.963 86.588-144.117 94.015V256h52c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-52v-5.47c37.281-13.178 63.995-48.725 64-90.518C384.005 43.772 341.605.738 289.37.01 235.723-.739 192 42.525 192 96c0 41.798 26.716 77.35 64 90.53V192h-52c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h52v190.015c-58.936-7.399-123.82-39.679-144.117-94.015h35.146c10.691 0 16.045-12.926 8.485-20.485l-67.029-67.029c-4.686-4.686-12.284-4.686-16.971 0L4.485 331.515C-3.074 339.074 2.28 352 12.971 352zM288 64c17.645 0 32 14.355 32 32s-14.355 32-32 32-32-14.355-32-32 14.355-32 32-32z"
        />
      </svg>
    )
  }
  
  
  
  export const Link = (props) => {
    return (
      <svg
        aria-hidden="true"
        data-prefix="fas"
        data-icon="link"
        className="prefix__svg-inline--fa prefix__fa-link prefix__fa-w-16"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 512 512"
        {...props}
        
      >
        <path
          fill={props.fill}
          
          d="M326.612 185.391c59.747 59.809 58.927 155.698.36 214.59-.11.12-.24.25-.36.37l-67.2 67.2c-59.27 59.27-155.699 59.262-214.96 0-59.27-59.26-59.27-155.7 0-214.96l37.106-37.106c9.84-9.84 26.786-3.3 27.294 10.606.648 17.722 3.826 35.527 9.69 52.721 1.986 5.822.567 12.262-3.783 16.612l-13.087 13.087c-28.026 28.026-28.905 73.66-1.155 101.96 28.024 28.579 74.086 28.749 102.325.51l67.2-67.19c28.191-28.191 28.073-73.757 0-101.83-3.701-3.694-7.429-6.564-10.341-8.569a16.037 16.037 0 01-6.947-12.606c-.396-10.567 3.348-21.456 11.698-29.806l21.054-21.055c5.521-5.521 14.182-6.199 20.584-1.731a152.482 152.482 0 0120.522 17.197zM467.547 44.449c-59.261-59.262-155.69-59.27-214.96 0l-67.2 67.2c-.12.12-.25.25-.36.37-58.566 58.892-59.387 154.781.36 214.59a152.454 152.454 0 0020.521 17.196c6.402 4.468 15.064 3.789 20.584-1.731l21.054-21.055c8.35-8.35 12.094-19.239 11.698-29.806a16.037 16.037 0 00-6.947-12.606c-2.912-2.005-6.64-4.875-10.341-8.569-28.073-28.073-28.191-73.639 0-101.83l67.2-67.19c28.239-28.239 74.3-28.069 102.325.51 27.75 28.3 26.872 73.934-1.155 101.96l-13.087 13.087c-4.35 4.35-5.769 10.79-3.783 16.612 5.864 17.194 9.042 34.999 9.69 52.721.509 13.906 17.454 20.446 27.294 10.606l37.106-37.106c59.271-59.259 59.271-155.699.001-214.959z"
        />
      </svg>
    )
  }
  
  
  
  export const Design = (props) => { 
    return (
      <svg
        aria-hidden="true"
        data-prefix="fas"
        data-icon="palette"
        className="prefix__svg-inline--fa prefix__fa-palette prefix__fa-w-16"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 512 512"
        {...props}
      >
        <path
          fill={props.fill}
          d="M204.3 5C104.9 24.4 24.8 104.3 5.2 203.4c-37 187 131.7 326.4 258.8 306.7 41.2-6.4 61.4-54.6 42.5-91.7-23.1-45.4 9.9-98.4 60.9-98.4h79.7c35.8 0 64.8-29.6 64.9-65.3C511.5 97.1 368.1-26.9 204.3 5zM96 320c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm32-128c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm128-64c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm128 64c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
        />
      </svg>
    )
  
  }
  
  export const Develope = (props) => { 
    return (
      <svg
        aria-hidden="true"
        data-prefix="fas"
        data-icon="laptop-code"
        className="prefix__svg-inline--fa prefix__fa-laptop-code prefix__fa-w-20"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 640 512"
        {...props}
      >
        <path
           fill={props.fill}
          d="M255.03 261.65c6.25 6.25 16.38 6.25 22.63 0l11.31-11.31c6.25-6.25 6.25-16.38 0-22.63L253.25 192l35.71-35.72c6.25-6.25 6.25-16.38 0-22.63l-11.31-11.31c-6.25-6.25-16.38-6.25-22.63 0l-58.34 58.34c-6.25 6.25-6.25 16.38 0 22.63l58.35 58.34zm96.01-11.3l11.31 11.31c6.25 6.25 16.38 6.25 22.63 0l58.34-58.34c6.25-6.25 6.25-16.38 0-22.63l-58.34-58.34c-6.25-6.25-16.38-6.25-22.63 0l-11.31 11.31c-6.25 6.25-6.25 16.38 0 22.63L386.75 192l-35.71 35.72c-6.25 6.25-6.25 16.38 0 22.63zM624 416H381.54c-.74 19.81-14.71 32-32.74 32H288c-18.69 0-33.02-17.47-32.77-32H16c-8.8 0-16 7.2-16 16v16c0 35.2 28.8 64 64 64h512c35.2 0 64-28.8 64-64v-16c0-8.8-7.2-16-16-16zM576 48c0-26.4-21.6-48-48-48H112C85.6 0 64 21.6 64 48v336h512V48zm-64 272H128V64h384v256z"
        />
      </svg>
    )
  
  }

  // created by me from this point

  export const Frontend = (props) => { 
    return (
      <svg
        aria-hidden="true"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 576 512"
        {...props}
      >
        <path
          fill={props.fill}
          d="M528 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM272 416H48V80h224v336zm256 0H304V80h224v336zM152 176c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm64 0c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm-128 0c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24z"
        />
      </svg>
    );
  };
  
  

  export const Backend = (props) => { 
    return (
      <svg
        aria-hidden="true"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 640 512"
        {...props}
      >
        <path
          fill={props.fill}
          d="M480 32H160c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32zm-16 384H176V80h288v336zM144 448h352c26.5 0 48 21.5 48 48s-21.5 48-48 48H144c-26.5 0-48-21.5-48-48s21.5-48 48-48zM208 96c-8.8 0-16 7.2-16 16s7.2 16 16 16h192c8.8 0 16-7.2 16-16s-7.2-16-16-16H208zm0 64c-8.8 0-16 7.2-16 16s7.2 16 16 16h192c8.8 0 16-7.2 16-16s-7.2-16-16-16H208zm0 64c-8.8 0-16 7.2-16 16s7.2 16 16 16h192c8.8 0 16-7.2 16-16s-7.2-16-16-16H208z"
        />
      </svg>
    );
  };
  

  export const Home = (props) => {
    return (
      <svg
        aria-hidden="true"
        data-prefix="fas"
        data-icon="home"
        className="prefix__svg-inline--fa prefix__fa-home prefix__fa-w-18"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 576 512"
        {...props}
      >
        <path
          fill={props.fill}
          d="M280.37 148.26L96 300.11V464a16 16 0 0016 16l112.11-.29a16 16 0 0015.89-16v-96a16 16 0 0116-16h32a16 16 0 0116 16v96a16 16 0 0016 16l112.11.29a16 16 0 0015.89-16V300.11l-184.37-151.85a12 12 0 00-15.26 0zM571.6 251.47l-25.51 20.66a12 12 0 01-15.89-.66L288 66.69 45.78 271.47a12 12 0 01-15.89.66L4.38 251.47a12 12 0 01-.66-17L260.49 43a36 36 0 0145 0l256.77 191.52a12 12 0 01-.66 17z"
        />
      </svg>
    );
  };

  

  // export const About = (props) => {
  //   return (
  //     <svg
  //       aria-hidden="true"
  //       data-prefix="fas"
  //       data-icon="user-circle"
  //       className="prefix__svg-inline--fa prefix__fa-user-circle prefix__fa-w-18"
  //       xmlns="http://www.w3.org/2000/svg"
  //       viewBox="0 0 512 512"
  //       {...props}
  //     >
  //       <path
  //         fill={props.fill}
  //         d="M256 8C114.6 8 0 122.6 0 256s114.6 248 256 248 256-122.6 256-248S397.4 8 256 8zM256 368c-88.4 0-160-71.6-160-160s71.6-160 160-160 160 71.6 160 160-71.6 160-160 160z"
  //       />
  //     </svg>
  //   );
  // };
  // export const Skills = (props) => {
  //   return (
  //     <svg
  //       aria-hidden="true"
  //       data-prefix="fas"
  //       data-icon="cogs"
  //       className="prefix__svg-inline--fa prefix__fa-cogs prefix__fa-w-18"
  //       xmlns="http://www.w3.org/2000/svg"
  //       viewBox="0 0 512 512"
  //       {...props}
  //     >
  //       <path
  //         fill={props.fill}
  //         d="M487.6 247.4l-40.3-23.3c7.2-31.2-2.2-64.5-26.7-87.9l-16.7-16.6c-23.4-23.4-56.7-33.8-87.9-26.6l-23.3-40.3c-13.4-23.3-40.3-38.2-69.5-38.2-29.2 0-56.1 14.9-69.5 38.2l-23.3 40.3c-31.2-7.2-64.5 2.2-87.9 26.6l-16.6 16.7c-23.4 23.4-33.8 56.7-26.7 87.9l-40.3 23.3c-23.3 13.4-38.2 40.3-38.2 69.5 0 29.2 14.9 56.1 38.2 69.5l40.3 23.3c-7.2 31.2 2.2 64.5 26.7 87.9l16.6 16.7c23.4 23.4 56.7 33.8 87.9 26.6l23.3 40.3c13.4 23.3 40.3 38.2 69.5 38.2 29.2 0 56.1-14.9 69.5-38.2l23.3-40.3c31.2 7.2 64.5-2.2 87.9-26.6l16.7-16.7c23.4-23.4 33.8-56.7 26.6-87.9z"
  //       />
  //     </svg>
  //   );
  // };

  // export const Work = (props) => {
  //   return (
  //     <svg
  //       aria-hidden="true"
  //       data-prefix="fas"
  //       data-icon="folder-open"
  //       className="prefix__svg-inline--fa prefix__fa-folder-open prefix__fa-w-18"
  //       xmlns="http://www.w3.org/2000/svg"
  //       viewBox="0 0 512 512"
  //       {...props}
  //     >
  //       <path
  //         fill={props.fill}
  //         d="M464 128H288l-32-32H64c-35.3 0-64 28.7-64 64v256c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V192c0-35.3-28.7-64-64-64zm32 320c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V192c0-17.7 14.3-32 32-32h192l32 32h128c17.7 0 32 14.3 32 32v256z"
  //       />
  //     </svg>
  //   );
  // };

  
  // export const Contact = (props) => {
  //   return (
  //     <svg
  //       aria-hidden="true"
  //       data-prefix="fas"
  //       data-icon="phone-alt"
  //       className="prefix__svg-inline--fa prefix__fa-phone-alt prefix__fa-w-18"
  //       xmlns="http://www.w3.org/2000/svg"
  //       viewBox="0 0 512 512"
  //       {...props}
  //     >
  //       <path
  //         fill={props.fill}
  //         d="M493.5 361.2l-92.5-92.5c-6.2-6.2-16.3-6.2-22.5 0l-42.1 42.1c-6.2 6.2-6.2 16.3 0 22.5l34.4 34.4c-24.7 17.1-54.9 26.2-86.3 26.2-40.5 0-78.1-14.8-107.8-41.8l-21.3-18.4c-22.4-19.3-45.2-41.5-70.7-67.1-25.7-25.7-47.5-48.4-66.9-70.6l-19.7-22.4c-27-29.7-42.8-64.5-42.8-106.6 0-40.3 12.9-79.3 37.5-114.4l31.5-39.7c6.2-7.6 5.6-18.9-1.5-25.3l-49.9-49.9c-7.3-7.3-17.7-7.7-25.3-1.5l-39.7 31.5C38.6 74.7 0 125.3 0 192c0 61.8 15.1 121.1 44.3 176.6 29.1 54.6 70.5 103.6 118.3 147.7 54.7 52.1 115.4 92.1 180.4 118.5 64.8 26.3 134.6 39.9 207.2 39.9 59.6 0 116.9-15.5 170.8-44.1 27.4-16.8 50.7-37.5 69.4-61.6 10.4-14.3 9.4-33.4-2.2-45.1z"
  //       />
  //     </svg>
  //   );
  // };
  


  export const WorkCase = (props) => {
    return (
      <svg
        aria-hidden="true"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 512 512"
        {...props}
      >
        <path
          fill={props.fill}
          d="M0,197.76 C54.58,218.99 112.18,231.45 170.67,234.67 V277.33 H256 V234.67 C314.34,231.01 371.83,218.87 426.67,198.61 V362.67 H0 V197.76 Z M277.33,0 L298.67,21.33 V64 H426.67 V175.15 C361.25,199.57 292.11,212.49 222.29,213.33 H206.93 C136.18,212.57 66.12,199.28 0,174.08 V64 H128 V21.33 L149.33,0 H277.33 Z M256,42.67 H170.67 V64 H256 V42.67 Z"
        />
      </svg>
    );
  };
  

  export const Mail = (props) => {
    return (
      <svg
        aria-hidden="true"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 -3.5 32 32"
        {...props}
      >
        <path
          fill={props.fill}
          d="M430,275.916 L426.684,273.167 L415.115,285.01 H444.591 L433.235,273.147 L430,275.916 Z M434.89,271.89 L445.892,283.329 C445.955,283.107 446,282.877 446,282.634 V262.862 L434.89,271.89 Z M414,262.816 V282.634 C414,282.877 414.045,283.107 414.108,283.329 L425.147,271.927 L414,262.816 Z M445,261 H415 L430,273.019 L445,261 Z"
        />
      </svg>
    );
  };
  

  export const About = (props) => {
    return (
      <svg
        aria-hidden="true"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 512 512"
        {...props}
      >
        <path
          fill={props.fill}
          d="M213.33,0C331.15,0 426.67,95.51 426.67,213.33C426.67,331.15 331.15,426.67 213.33,426.67C95.51,426.67 0,331.15 0,213.33C0,95.51 95.51,0 213.33,0ZM234.71,192H192v128h42.71V192ZM213.55,101.33c-15.55,0-26.83,11.22-26.83,26.37c0,15.76,11.99,26.96,26.83,26.96c15.23,0,26.49-11.2,26.49-26.67C240.05,112.55,228.78,101.33,213.55,101.33Z"
        />
      </svg>
    );
  };
  

  export const Skills = (props) => {
    return (
      <svg
        aria-hidden="true"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        {...props}
      >
        <path
          fill={props.fill}
          d="M22 12C22 17.52 17.52 22 12 22S2 17.52 2 12 6.48 2 12 2s10 4.48 10 10zm-8.51-5.55c.4.11.64.52.53.92l-2.59 9.66c-.11.4-.52.64-.92.53-.4-.11-.64-.52-.53-.92l2.59-9.66c.11-.4.52-.64.92-.53zm1.48 2.02c.29-.29.77-.29 1.06 0l.21.21c.64.64 1.17 1.18 1.53 1.65.38.5.65 1.03.65 1.67 0 .64-.27 1.18-.65 1.67-.36.47-.89 1.01-1.53 1.65l-.21.21c-.29.29-.77.29-1.06 0s-.29-.77 0-1.06l.17-.17c.68-.68 1.14-1.14 1.42-1.48.26-.33.3-.54.3-.78 0-.24-.04-.45-.3-.78-.28-.34-.74-.8-1.42-1.48l-.17-.17c-.29-.29-.29-.77 0-1.06zm-6.97 0c.29-.29.77-.29 1.06 0s.29.77 0 1.06l-.17.17c-.68.68-1.14 1.14-1.42 1.48-.26.33-.3.54-.3.78 0 .24.04.45.3.78.28.34.74.8 1.42 1.48l.17.17c.29.29.29.77 0 1.06s-.77.29-1.06 0l-.21-.21c-.64-.64-1.17-1.18-1.53-1.65-.38-.5-.65-1.03-.65-1.67 0-.64.27-1.18.65-1.67.36-.47.89-1.01 1.53-1.65l.21-.21z"
        />
      </svg>
    );
  };
  